import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./redux/store";
import PublicRoutes from "./router";
import { ThemeProvider } from "styled-components";
import { ConfigProvider } from "antd";
import { IntlProvider } from "react-intl";
import themes from "./settings/themes";
import { themeConfig } from "./settings";
import config, {
  getCurrentLanguage,
} from "./containers/LanguageSwitcher/config";
import DashAppHolder from "./dashAppStyle";
import Boot from "./redux/boot";

const loadCurrentLocale = async () => {
  const selectedLocale = getCurrentLanguage(config.defaultLanguage || "english").locale;

  switch (selectedLocale) {
    case "zh":
      return (await import("./languageProvider/entries/zh-Hans-CN")).default;
    case "es":
      return (await import("./languageProvider/entries/es_ES")).default;
    case "fr":
      return (await import("./languageProvider/entries/fr_FR")).default;
    case "it":
      return (await import("./languageProvider/entries/it_IT")).default;
    case "sa":
      return (await import("./languageProvider/entries/ar_SA")).default;
    case "en":
    default:
      return (await import("./languageProvider/entries/en-US")).default;
  }
};

const DashApp = () => {
  const [currentAppLocale, setCurrentAppLocale] = useState(null);

  useEffect(() => {
    let mounted = true;

    loadCurrentLocale().then((localeData) => {
      if (mounted) {
        setCurrentAppLocale(localeData);
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  if (!currentAppLocale) {
    return null;
  }

  return (
    <ConfigProvider locale={currentAppLocale.antd}>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <ThemeProvider theme={themes[themeConfig.theme]}>
          <DashAppHolder style={{ height: "100%" }}>
            <Provider store={store}>
              <BrowserRouter
                future={{
                  v7_startTransition: true,
                  v7_relativeSplatPath: true,
                }}
              >
                <PublicRoutes />
              </BrowserRouter>
            </Provider>
          </DashAppHolder>
        </ThemeProvider>
      </IntlProvider>
    </ConfigProvider>
  );
};

Boot()
  .then(() => DashApp())
  .catch((error) => console.error(error));

export default DashApp;
